import script from "./driver-task-list.vue?vue&type=script&setup=true&lang=js"
export * from "./driver-task-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__